var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("error",null,{"props_error":_vm.errors})],2)}
var staticRenderFns = []

export { render, staticRenderFns }